import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCourse = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 13,
	viewBox: "0 0 15 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 3.98113C0.749995 3.91801 0.764806 3.85494 0.794354 3.79664C0.859671 3.66777 1.05254 3.57263 1.43829 3.38236L5.48099 1.3883C6.18933 1.03892 6.54349 0.864223 6.91653 0.795582C7.24682 0.734806 7.58651 0.734806 7.9168 0.795582C8.28984 0.864223 8.64401 1.03892 9.35234 1.3883L13.395 3.38236C13.7808 3.57263 13.9737 3.66777 14.039 3.79664C14.0959 3.90894 14.0981 4.03896 14.0451 4.15294C13.9843 4.28373 13.7948 4.38468 13.4157 4.58658L9.47065 6.68817C8.72167 7.08716 8.34718 7.28665 7.94982 7.3648C7.59819 7.43396 7.23514 7.43396 6.88351 7.3648C6.48615 7.28665 6.11166 7.08716 5.36268 6.68817L1.41759 4.58658C1.03858 4.38468 0.849081 4.28373 0.788228 4.15294C0.762726 4.09813 0.750005 4.03961 0.75 3.98113ZM0.75 3.98113V8.75M2.75 5.29637V9.50713C2.75 9.73258 2.75 9.8453 2.7829 9.94611C2.81202 10.0353 2.85963 10.1174 2.92263 10.1869C2.99383 10.2655 3.09171 10.3214 3.28745 10.4333L3.71216 10.6759C5.06241 11.4475 5.73755 11.8333 6.45454 11.9844C7.08899 12.1181 7.74434 12.1181 8.37879 11.9844C9.09578 11.8333 9.77092 11.4475 11.1212 10.6759L11.5459 10.4333C11.7416 10.3214 11.8395 10.2655 11.9107 10.1869C11.9737 10.1174 12.0213 10.0353 12.0504 9.94611C12.0833 9.8453 12.0833 9.73897 12.0833 9.51352V5.29637",
		stroke: "#DC2626",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCourse);
export default ForwardRef;
